import React from 'react';
import PropTypes from 'prop-types';
import LoadErrorMessage from './LoadErrorMessage';
import LoadProgress from './LoadProgress';
import parentTestService from '../../services/ParentTestService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import testStatusConstants from '../../constants/TestStatusConstants';
import DescriptionDocument from './DescriptionDocument';
import styles from './testOverview.scss';
import { t } from '../../services/i18nService';
import testComponentService from '../../services/TestComponentService';
import sessionReader from '../../store/readHelpers/SessionReader';
import StartChildTest from './StartChildTest';

// Keep component state-free and service-free.
export class PureTestComponentTestInfo extends React.PureComponent {
    static propTypes = {
        parentTest: PropTypes.object.isRequired,
        test: PropTypes.object.isRequired,
        cacheStatus: PropTypes.object.isRequired,
        navigationLock: PropTypes.object.isRequired,

        // resolved
        shouldShowWait: PropTypes.bool.isRequired,
        requireManualStart: PropTypes.bool.isRequired,
        showDescriptionDocument: PropTypes.bool.isRequired,
        shouldShowLoadProgress: PropTypes.bool.isRequired,
        shouldShowErrorMessage: PropTypes.bool.isRequired,
        testCanBeStarted: PropTypes.bool.isRequired,
    };

    render() {
        const {
            parentTest,
            test,
            cacheStatus,
            navigationLock,
            requireManualStart,
            showDescriptionDocument,
            shouldShowWait,
            shouldShowLoadProgress,
            shouldShowErrorMessage,
            testCanBeStarted,
        } = this.props;

        return (
            <React.Fragment>
                {
                    showDescriptionDocument ?
                        <DescriptionDocument
                            test={test}
                            navigationLock={navigationLock}
                        />
                        : null
                }
                {
                    shouldShowWait ?
                        <div className={`${styles.actionBox} ${styles.current}`}>
                            <span className={styles.text}>
                                <i className="fa fa-clock-o" aria-hidden />&nbsp;
                                {
                                    parentTest.minutesUntilChildStartTime <= 1
                                        ? t('childTest.pleaseWaitOneMinute')
                                        : t('childTest.pleaseWait', { minutes: parentTest.minutesUntilChildStartTime })
                                }
                            </span>
                        </div>
                        : null
                }
                {
                    shouldShowLoadProgress ?
                        <LoadProgress id={test.assessmentRunId} notifyOnTimeout cacheStatus={cacheStatus} />
                        : null
                }
                {
                    shouldShowErrorMessage
                        ? <LoadErrorMessage cacheStatus={cacheStatus} />
                        : null
                }
                {
                    testCanBeStarted
                        ? <StartChildTest test={test} requireManualStart={requireManualStart} />
                        : null
                }
            </React.Fragment>
        );
    }
}

const TestComponentTestInfo = (ownProps) => {
    const { cacheStatus, test } = ownProps;
    const testSettings = parentTestService.getSettingsForPendingTest(test.assessmentRunId);
    const shouldCacheResourcesBeforeTestStart = settingsReader.shouldCacheResourcesBeforeTestStart(testSettings);
    const testWithStatus = testComponentService.getTestWithStatus(test);

    const resolvedProps = {
        requireManualStart: settingsReader.isManualStart(testSettings),
        showDescriptionDocument: testWithStatus.status === testStatusConstants.EXECUTING && sessionReader.isParentTest(),
        shouldShowWait: testWithStatus.status === testStatusConstants.SCHEDULED,
        shouldShowLoadProgress: testComponentService.shouldShowLoadProgress(cacheStatus, testWithStatus, shouldCacheResourcesBeforeTestStart),
        shouldShowErrorMessage: testComponentService.testResourcesIncompletelyCached(cacheStatus, shouldCacheResourcesBeforeTestStart),
        testCanBeStarted: testComponentService.testCanBeStarted(cacheStatus, testWithStatus, shouldCacheResourcesBeforeTestStart),
    };

    return <PureTestComponentTestInfo {...ownProps} {...resolvedProps} />;
};


export default TestComponentTestInfo;
